import MailIcon from '@mui/icons-material/Mail';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import { Box, CssBaseline, GlobalStyles } from '@mui/material';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/jazminmya.png';
import { Login } from '../../components';

const Home = ({ setOptions, setChildHeader }) => {
  const anchor = 'left';
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  useEffect(() => {
    setOptions && setOptions([])
    setChildHeader && setChildHeader(null)
  }, [])

  const list = (anchor) => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {[{ tittle: 'Articulos', path: '/articulos' }, { tittle: 'Categorias', path: '/categorias' }, { tittle: 'Movimientos', path: '/movimientos' }].map(({ tittle, path }, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton onClick={() => { console.log(tittle + ' ' + path); navigate(path) }}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={tittle} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            padding: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          },
          html: {
            margin: 0,
            padding: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          },
          '#root': {
            width: '100%',
            height: '100%',
          },
        }}
      />
      <Box
        sx={{
          position: 'relative',
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'stretch',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="background"
          sx={{
            background: '#fbeeee',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain', // Ajusta la imagen para que se ajuste dentro del contenedor
            zIndex: -1, // Coloca la imagen detrás del contenido
          }}
        />
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            padding: '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.8)', // Fondo blanco semitransparente para el contenido
            borderRadius: '10px',
            width: { xs: '90%', sm: '70%', md: '50%', lg: '40%' }, // Ancho adaptable a diferentes tamaños de pantalla
            maxWidth: '600px', // Ancho máximo para evitar que crezca demasiado en pantallas grandes
            textAlign: 'center', // Para centrar el texto
          }}
        >
          {/* Aquí puedes colocar el contenido que desees */}
          <h1>Bienvenido</h1>
          <Login />
        </Box>
      </Box>
    </>
  );
}

export default Home;